import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { LocalServiceService } from '../../../shareModule/services/local-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-manage-brands',
  templateUrl: './manage-brands.component.html',
  styleUrls: ['./manage-brands.component.scss']
})
export class ManageBrandsComponent implements OnInit {
  private modalRef: any;
  brands: any;
  order_detail: any;
  imgUrl = environment.ImageUrl;
  name: string = '';
  description: string = '';
  title: string = '';
  url: string = '';
  id: any = null
  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private router: Router,
    private local: LocalServiceService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.initData();
  }

  initData() {
    this.auth.brands_fetch().subscribe((response: any) => {
      this.brands = response.body;
    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message);
      }
    });
  }

  openModal(content: any, item: any = {}) {
    this.modalService.open(content, {
      windowClass: 'upload_file_modal custom-width mt-5',
      // backdrop: 'static',
      keyboard: false,
      size: 'xs',
    });

    this.id = null;
    this.name = '';
    this.title = this.description = '';
    this.url = ''
    if (item) {
      this.id = item.id
      this.name = item.name
      this.description = item.description
      this.url = item.url,
        this.title = item.title
    }
  }


  fileUpload: File | null = null
  thumbnail: string | null = null
  onFileSelected(event: any) {
    this.fileUpload = null
    this.thumbnail = null
    const file: File = event.target.files[0];
    if (file) {
      if (file.type.startsWith('image/')) {
        this.fileUpload = file
        // const reader = new FileReader();
        // reader.onload = (e: any) => {
        //   console.log('Data URL:', e.target.result);
        // };
        this.toastr.success(`Selected image file: ${file.name}`);
      } else {
        this.toastr.warning("Please select an image file");
      }
    } else {
      this.toastr.warning("No file selected");
    }
  }

  isUploading: boolean = false
  handleUpload() {

    const payload = new FormData();
    if (this.fileUpload != null) {

      payload.append('image', this.fileUpload as Blob);
    }
    payload.append('name', this.name);
    if (this.id) {
      payload.append('id', this.id);
    }
    payload.append('url', this.url);
    payload.append('description', this.description);
    payload.append('title', this.title);


    this.isUploading = true

    this.auth.brands_add(payload)
      .subscribe((response: any) => {
        this.modalService.dismissAll()
        this.toastr.success('Brand added successfully')
        this.isUploading = false
        this.initData()
      }, (e) => {
        this.toastr.error(e.error.message)
        this.isUploading = false
      })

  }

  handleDelete(id: any) {
    this.local.alertConfirm({ message: 'Are you sure you want to delete this brand?' }).then((res: any) => {
      if (res.isConfirmed) {
        this.auth.brands_delete(id).subscribe((response: any) => {
          this.toastr.success('Deleted successfully')
          this.initData()
        }, (e) => {
          this.toastr.error(e.error.message)
        })
      }
    })
  }
}
